<template>
  <InputNumber
    @on-change="change"
    :min="0"
    style="width: 100%"
    v-model="number"
  >
  </InputNumber>
</template>
<script>
export default {
  props: ["aaa", "beishu"],
  data() {
    return {
      number: 0,
    };
  },
  methods: {
    change(v) {
      var beishu = this.beishu==undefined ? 1 : this.beishu;
      this.$emit("bbb", v * beishu);
    },
    ff() {
      var beishu = this.beishu==undefined ? 1 : this.beishu;
      this.number = Math.ceil(this.aaa / beishu);
    },
  },
  model: {
    prop: "aaa",
    event: "bbb",
  },
  mounted() {
    this.ff();
  },
  watch: {
    aaa() {
      this.ff();
    },
  },
};
</script>


// WEBPACK FOOTER //
// ../common/src/components/duration.vue